import { css } from '@emotion/react'
import { useModal } from 'components/modal/Modal'
import { BREAKPOINTS, pxToRem } from 'utils/styled'
import {
  SInfo,
  SInfoSideModal,
  SInfoTextColumn,
  SInfoTitle,
  SSubtitle,
  SText,
  STitle,
} from './InfoSideModal.styled'
import { ReactElement } from 'react'
import { useOuterClick } from 'utils/hooks'
import { BlockSpinner } from 'components/spinner/Spinner'
import { useDynamicTranslations } from 'utils/i18n/useDynamicTranslations'

interface Info {
  title?: string
  description?: string
  icon?: ReactElement
}

const InfoSideModal = (props: { title?: string; infoList?: Info[]; onClose: () => void }) => {
  const { t, isLoading } = useDynamicTranslations('memory')
  const ref = useOuterClick(props.onClose)
  if (isLoading) return <BlockSpinner />
  return (
    <SInfoSideModal ref={ref}>
      <STitle>{t('memory.info_side_modal.title')}</STitle>
      <SSubtitle>{props.title}</SSubtitle>
      {props.infoList?.map((info) => (
        <SInfo key={`${info.title}-${info.description}`}>
          {info.icon}
          <SInfoTextColumn>
            <SInfoTitle>{info.title}</SInfoTitle>
            <SText>{info.description}</SText>
          </SInfoTextColumn>
        </SInfo>
      ))}
    </SInfoSideModal>
  )
}

export const useInfoSideModal = (props: { title?: string; infoList?: Info[] }) => {
  const [infoSideModal, openInfoSideModal, closeInfoSideModal] = useModal(
    ({ close, isOpen }) =>
      isOpen ? (
        <InfoSideModal title={props.title} infoList={props.infoList} onClose={close} />
      ) : null,
    {
      modalCss: css`
        padding: 0;
        @media ${BREAKPOINTS.MD.min} {
          display: flex;
          position: fixed;
          right: 0;
          top: 0;
          bottom: 0;
          width: ${pxToRem(400)}rem;
        }
      `,
      modalContentCss: css`
        @media ${BREAKPOINTS.MD.min} {
          flex: 1;
        }
      `,
    }
  )
  return [infoSideModal, openInfoSideModal, closeInfoSideModal] as const
}
